import React, { useEffect, useState } from "react";
import { MARK_STYLE, localIso } from "./AttendanceTab";

const TOT = [["P", "Present"], ["HD", "Half day"], ["A", "Absent"], ["L", "Leave"], ["WO", "Weekly off"], ["H", "Holiday"]];

// Phone view: one person at a time as a month calendar.
export function AttendanceMobile({ data, isHr, onCell }) {
  const [uid, setUid] = useState(data.rows[0]?.user_id);
  useEffect(() => { if (!data.rows.some((r) => r.user_id === uid)) setUid(data.rows[0]?.user_id); }, [data, uid]);
  const row = data.rows.find((r) => r.user_id === uid);
  if (!row) return <div className="p-8 text-center text-sm text-slate-500">No attendance to show.</div>;
  const lead = (new Date(`${data.days[0]}T00:00:00`).getDay() + 6) % 7;
  const todayIso = localIso();
  return (
    <div className="space-y-3" data-testid="attendance-mobile">
      {isHr && data.rows.length > 1 && (
        <select value={uid} onChange={(e) => setUid(e.target.value)} className="h-11 w-full rounded-xl border border-slate-300 px-3 text-sm font-semibold bg-white" data-testid="attendance-mobile-employee">
          {data.rows.map((r) => <option key={r.user_id} value={r.user_id}>{r.name}{!r.jibble_matched && data.jibble.ok ? " (not on Jibble)" : ""}</option>)}
        </select>
      )}
      <div className="grid grid-cols-3 gap-2" data-testid="attendance-mobile-totals">
        {TOT.map(([k, l]) => (
          <div key={k} className={`rounded-xl px-3 py-2 ${MARK_STYLE[k]}`}><div className="text-[10px] uppercase font-bold opacity-80">{l}</div><div className="font-heading text-xl font-bold tabular-nums">{row.totals[k]}</div></div>
        ))}
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl p-3">
        <div className="grid grid-cols-7 gap-1.5 text-center text-[10px] font-bold text-slate-400 mb-1.5">{["M", "T", "W", "T", "F", "S", "S"].map((d, i) => <div key={i}>{d}</div>)}</div>
        <div className="grid grid-cols-7 gap-1.5">
          {Array.from({ length: lead }).map((_, i) => <div key={`b${i}`} />)}
          {data.days.map((d) => {
            const m = row.marks[d] || "";
            return (
              <button key={d} type="button" onClick={(e) => onCell(e, row, d)}
                className={`relative aspect-square rounded-xl flex flex-col items-center justify-center transition-transform active:scale-95 ${MARK_STYLE[m] || "bg-slate-50 text-slate-400"} ${d === todayIso ? "ring-2 ring-red-500" : ""}`}
                data-testid={`attendance-mobile-day-${d}`}>
                <span className="text-sm font-bold leading-none">{Number(d.slice(8))}</span>
                <span className="text-[9px] font-bold mt-0.5 leading-none">{m || " "}</span>
                {row.hours?.[d] ? <span className="text-[8px] opacity-70 leading-none mt-0.5">{row.hours[d]}h</span> : null}
                {row.overridden?.includes(d) && <span className="absolute top-1 right-1 h-1.5 w-1.5 rounded-full bg-slate-900" />}
              </button>
            );
          })}
        </div>
      </div>
      {isHr && <div className="text-[11px] text-slate-500 text-center">Tap a day to mark it yourself. A dot means a manual mark.</div>}
    </div>
  );
}
